module.exports = __webpack_public_path__ + "static/img/avatarframe1.16be9c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/newYear/avatarframe1.png
// module id = UkaZ
// module chunks = 87